import React from 'react';
import P from 'components/elements/p';
import Box from 'components/elements/Box';
import { useCopyToClipboard } from 'react-use';
import Button from 'components/elements/button';
import { Input as InputBase } from 'components/customlists/shared/styles';
import styled from 'styled-components/macro';
import { ReactComponent as IconRefresh } from 'icons/icon-refresh.svg';
import { logToAmplitude } from 'helpers/logAmplitudeEvent';

const Input = styled(InputBase)`
  margin-right: ${({ theme }): string => `${theme.spacing.small}`};
  background: none;
  border-color: ${({ theme }): string => theme.CasperGrey};
`;

interface ICopyInvitationUrl {
  link: string;
  refreshAction?: () => void;
}

const CopyInvitationUrl: React.FC<ICopyInvitationUrl> = (props) => {
  const [state, copyToClipboard] = useCopyToClipboard();
  const { link, refreshAction } = props;

  const onCopyClick = (): void => {
    copyToClipboard(link);
    logToAmplitude('User has copied the invitation link to the List', {
      type: refreshAction ? 'Curators' : 'Viewers',
    });
  };

  return (
    <>
      <Box display="flex" justifyContent="center" mb="3">
        {refreshAction && (
          <Button
            variant="secondary"
            display="flex"
            alignItems="center"
            mr={3}
            onClick={refreshAction}
          >
            <IconRefresh />
          </Button>
        )}
        <Input type="text" value={link} readOnly />
        <Button onClick={onCopyClick} variant="primary">
          Copy URL
        </Button>
      </Box>
      <Box display="flex" justifyContent="center" mb="3">
        {state.error ? (
          <P color={'NotificationOrange'}>
            Unable to copy value: {state.error.message}
          </P>
        ) : (
          state.value && (
            <P color={'AccentGreen'}>
              The URL has been copied to your clipboard
            </P>
          )
        )}
      </Box>
    </>
  );
};

export default CopyInvitationUrl;
